export default "__VITE_ASSET__Dzc9pMIX__"